import React from 'react';

function Twilio(props) {
    const className = props.className;
    return (
        // width/height kept as a default for callers that wrap this in a sized
        // span (e.g. Integrations.js); when a className with explicit
        // dimensions is passed (source-icon-svg → 100%), CSS overrides them.
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 68.3 68.3"
            fill="none"
            className={className}
        >
            <g fill="#e31e26">
                <path d="M34.1 0C15.3 0 0 15.3 0 34.1s15.3 34.1 34.1 34.1C53 68.3 68.3 53 68.3 34.1S53 0 34.1 0zm0 59.3C20.3 59.3 9 48 9 34.1 9 20.3 20.3 9 34.1 9 48 9 59.3 20.3 59.3 34.1 59.3 48 48 59.3 34.1 59.3z" />
                <circle cx="42.6" cy="25.6" r="7.1" />
                <circle cx="42.6" cy="42.6" r="7.1" />
                <circle cx="25.6" cy="42.6" r="7.1" />
                <circle cx="25.6" cy="25.6" r="7.1" />
            </g>
        </svg>
    )
};

export default Twilio;
